export default __webpack_public_path__ + "static/media/pic2.df168a90.jpg";